import { ConfigurationModel } from "@/models/configuration-model";

export type State = {
  configBagsizeId: string | null | undefined
  configBodyId: string | null | undefined
  configEdgeId: string | null | undefined
  configThreadId: string | null | undefined
  configInsideId: string | null | undefined
  configPocketId: string | null | undefined
  configSideId: string | null | undefined
  configFrontId: string | null | undefined
  configTackId: string | null | undefined
  configBackId: string | null | undefined
  configNamechar: string | null | undefined
  configNamethreadId: string | null | undefined
  configNonameId: string | null | undefined

  configLoaded :boolean
}

export const state: State = {
  configBagsizeId: undefined,
  configBodyId: undefined,
  configEdgeId: undefined,
  configThreadId: undefined,
  configInsideId: undefined,
  configPocketId: undefined,
  configSideId: undefined,
  configFrontId: undefined,
  configTackId: undefined,
  configBackId: undefined,
  configNamechar: undefined,
  configNamethreadId: undefined,
  configNonameId: undefined,

  configLoaded: false
};
